import { render, staticRenderFns } from "./HistoricalPrices.vue?vue&type=template&id=1101998b&scoped=true&"
import script from "./HistoricalPrices.vue?vue&type=script&lang=js&"
export * from "./HistoricalPrices.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalPrices.vue?vue&type=style&index=0&id=1101998b&lang=scss&scoped=true&"
import style1 from "./HistoricalPrices.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1101998b",
  null
  
)

export default component.exports